import { atom } from "jotai";

export const orgLoadingAtom = atom(false);
